import React from 'react';
class ComingSoon extends React.Component {
    render () {
        return (
            <div className="coming-soon"></div>
        )
    }
}

export default ComingSoon;
